import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { AutomationRule, AutomationRuleDetails, AutomationRuleIndex, Station } from './automation-rules.model';

@Injectable({
  providedIn: 'root'
})
export class AutomationRulesService {

  constructor(private appServerAPI: AppServerAPI) { }

  getRules(): Observable<AutomationRule[]> {
    return this.appServerAPI.execute<AutomationRule[]>('/client/admin/automation/rule', {});
  }

  getDetails(ruleId: number): Observable<AutomationRuleDetails> {
    return this.appServerAPI.execute<AutomationRuleDetails>('/client/admin/automation/rule/details', ruleId);
  }

  saveDetails(rule: AutomationRuleDetails): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/automation/rule/save', rule);
  }

  saveRulesIndex(rulesIndices: AutomationRuleIndex[]){
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/automation/rule/save-indeces', rulesIndices);
  }

  deleteRule(ruleId: number): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/automation/rule/delete', ruleId);
  }

  getStations(): Observable<Station[]> {
    return this.appServerAPI.execute<Station[]>('/client/admin/automation/rule/stations', {});
  }

}
